<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-card elevation="0">
                    <v-card-title>
                        Custom Timetable Entries
                    </v-card-title>
                    <v-data-table :headers="headers" :items="timetable" :search="search" :loading="timetableloading" loading-text="Loading Timetable..."
                        show-expand :expanded.sync="expanded" single-expand :items-per-page="5" dense
                    >
                        <template v-slot:item.mon="{ item }">
                            <v-checkbox v-model="item.mon" disabled true-value="Mon"></v-checkbox>
                        </template>
                        <template v-slot:item.tues="{ item }">
                            <v-checkbox v-model="item.tues" disabled true-value="Tue"></v-checkbox>
                        </template>
                        <template v-slot:item.wed="{ item }">
                            <v-checkbox v-model="item.wed" disabled true-value="Wed"></v-checkbox>
                        </template>
                        <template v-slot:item.thurs="{ item }">
                            <v-checkbox v-model="item.thurs" disabled true-value="Thu"></v-checkbox>
                        </template>
                        <template v-slot:item.fri="{ item }">
                            <v-checkbox v-model="item.fri" disabled true-value="Fri"></v-checkbox>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length">
                                <v-card elevation="0" outlined>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="5">
                                                <v-simple-table style="width: 100%; border: none; border-collapse:collapse;">
                                                    <template v-slot:default>
                                                        <tbody>
                                                            <tr style="height: 20px">
                                                                <th>Campus</th>
                                                                <td>{{ item.campus }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th>Location</th>
                                                                <td>{{ item.location }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th>Capacity</th>
                                                                <td>{{ item.enrlcap }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th>Instructor</th>
                                                                <td>{{ item.instructorname }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th>Session</th>
                                                                <td>{{ item.sessioncode }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th>Time</th>
                                                                <td>{{ splitMeetingTime(item.meetingtimestart) }}-{{ splitMeetingTime(item.meetingtimeend) }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                            <v-col cols="7">
                                                <v-simple-table style="width: 100%; border: none; border-collapse:collapse;">
                                                    <template v-slot:default>
                                                        <tbody>
                                                            <tr style="height: 20px">
                                                                <th>Academic Group</th>
                                                                <td>{{ item.acadgroup }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th>Facility</th>
                                                                <td>{{ item.facilityid }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th>Associated Class</th>
                                                                <td>{{ item.associatedclass }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th rowspan="2">Description</th>
                                                                <td>{{ item.descr }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <td>{{ item.descrlong }}</td>
                                                            </tr>
                                                            <tr style="height: 20px">
                                                                <th>Updated By</th>
                                                                <td v-if="item.hasOwnProperty('updatedByCommonName')">{{ item.updatedByCommonName }}</td>
                                                                <td v-else>{{ item.createdByCommonName }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn dark color="#29A0B1" @click="openEditDialog(item)"><v-icon>mdi-table-edit</v-icon>&nbsp;Edit</v-btn>
                                        <v-btn color="#FB4570" outlined @click="openDeleteDialog(item)"><v-icon>mdi-table-remove</v-icon>&nbsp;Delete</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialogDelete" max-width="650px" persistent>
            <v-card>
                <v-toolbar color="#EF7C8E" dark>
                    <v-toolbar-title>Delete this timetable record?</v-toolbar-title>
                </v-toolbar><br />
                <v-card-text>
                    The following custom entry will be deleted: <br />
                    <v-simple-table style="width: 100%; border: none; border-collapse:collapse;">
                        <template v-slot:default>
                            <tbody>
                                <tr style="height: 20px">
                                    <th>Strm</th>
                                    <td>{{ selectedRecordDelete.strm }}</td>
                                </tr>
                                <tr style="height: 20px">
                                    <th>Subject</th>
                                    <td>{{ selectedRecordDelete["subject-resolved"] }}</td>
                                </tr>
                                <tr style="height: 20px">
                                    <th>Class Number</th>
                                    <td>{{ selectedRecordDelete.classnbr }}</td>
                                </tr>
                                <tr style="height: 20px">
                                    <th>Catalog Number</th>
                                    <td>{{ selectedRecordDelete.catalognbr }}</td>
                                </tr>
                                <tr style="height: 20px">
                                    <th>Associated Class</th>
                                    <td>{{ selectedRecordDelete.associatedclass }}</td>
                                </tr>
                                <tr style="height: 20px">
                                    <th>SSR Component</th>
                                    <td>{{ selectedRecordDelete.ssrcomponent }}</td>
                                </tr>
                                <tr style="height: 20px">
                                    <th>Session Code</th>
                                    <td>{{ selectedRecordDelete.sessioncode }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <br />
                    Are you sure to Continue?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#8FDDE7" dark @click="dialogDelete = false">Cancel</v-btn>
                    <v-btn color="#EF7C8E" outlined @click="deleteRecord" :loading="deletebtnloading">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogUpdate" persistent>
            <v-card>
                <v-toolbar color="#29A0B1" dark>
                    <v-toolbar-title>Update Custom Timetable Record</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogUpdate = false">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar><br />
                <v-card-text v-if="dialogUpdate">
                    <v-row class="ma-0 pa-1">
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.strm" label="Strm"></v-text-field></v-col>
                        <v-col cols="12" md="4" class="ma-0 pa-1"><v-select dense outlined v-model="selectedRecordUpdate.subject" :items="disciplineitems" label="Discipline" item-text="label" item-value="value"></v-select></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.location" label="Location" ></v-text-field></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.acadgroup" label="Group" ></v-text-field></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-select dense outlined v-model="selectedRecordUpdate.ssrcomponent" :items="ssritems" label="SSR Comp." ></v-select></v-col>
                        <v-col cols="12" md="3" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.classsection" label="Class Section" ></v-text-field></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.classnbr" label="Class Number" ></v-text-field></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.catalognbr" label="Catalog Number" ></v-text-field></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.enrlcap" label="Enrolment Capacity"></v-text-field></v-col>
                        <v-col cols="12" md="3" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.facilityid" label="Facility ID"></v-text-field></v-col>
                        <v-col cols="12" md="6" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.instructorname" label="Instructor Name"  ></v-text-field></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.campus" label="Campus"></v-text-field></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.associatedclass" label="Assoc. Class"></v-text-field></v-col>
                        <v-col cols="12" md="2" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.sessioncode" label="Session Code"></v-text-field></v-col>
                        <v-col cols="12" md="12" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.descr" label="Description (title)"></v-text-field></v-col>
                        <v-col cols="12" md="12" class="ma-0 pa-1"><v-textarea height="100" outlined v-model="selectedRecordUpdate.descrlong" label="Description (detail)"></v-textarea></v-col>
                        <v-col cols="12" md="6" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.meetingtimestart" label="Meeting Time (start)" :rules="[v=> /^[0-9]{2}:[0-9]{2}$/.test(v) || 'Invalid Format (HH:MM in 24-hour format)']"></v-text-field></v-col>
                        <v-col cols="12" md="6" class="ma-0 pa-1"><v-text-field dense outlined v-model="selectedRecordUpdate.meetingtimeend" label="Meeting Time (end)" :rules="[v=> /^[0-9]{2}:[0-9]{2}$/.test(v) || 'Invalid Format (HH:MM  in 24-hour format)']"></v-text-field></v-col>
                        <v-col cols="12" md="6" class="ma-0 pa-1">
                            <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Mon</th>
                                            <th>Tue</th>
                                            <th>Wed</th>
                                            <th>Thu</th>
                                            <th>Fri</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><v-checkbox v-model="selectedRecordUpdate.mon" value="Mon" true-value="Mon" false-value=""></v-checkbox></td>
                                            <td><v-checkbox v-model="selectedRecordUpdate.tues" value="Tue" true-value="Tue" false-value=""></v-checkbox></td>
                                            <td><v-checkbox v-model="selectedRecordUpdate.wed" value="Wed" true-value="Wed" false-value=""></v-checkbox></td>
                                            <td><v-checkbox v-model="selectedRecordUpdate.thurs" value="Thu" true-value="Thu" false-value=""></v-checkbox></td>
                                            <td><v-checkbox v-model="selectedRecordUpdate.fri" value="Fri" true-value="Fri" false-value=""></v-checkbox></td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#29A0B1" dark @click="updateRecord" :loading="updatebtnloading">Update</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            loading: false,
            timetableloading: false,
            search: "",
            expanded: [],
            headers: [
                {text: "Stream" , value: "strm"},
                {text: "Section" , value: "classsection"},
                {text: "Subject" , value: "subject-resolved"},
                {text: "Department" , value: "academicdepartment"},
                {text: "Catalog" , value: "catalognbr"},
                {text: "Class #" , value: "classnbr"},
                {text: "Component", value: "ssrcomponent"},
                {text: "Mon", value: "mon"},
                {text: "Tue", value: "tues"},
                {text: "Wed", value: "wed"},
                {text: "Thu", value: "thurs"},
                {text: "Fri", value: "fri"},
                {text: '', value: 'data-table-expand'},
            ],
            timetable: [],
            disciplineitems: [],
            ssritems: ['LEC', 'TUT', 'LAB'],
            dialogDelete: false,
            dialogUpdate: false,
            selectedRecordDelete: {},
            selectedRecordUpdate: {},
            updatebtnloading: false,
            deletebtnloading: false
        }
    },
    methods: {
        splitMeetingTime(meetingtime){
            return meetingtime.split(" ")[1]
        },
        splitMeetingTime(meetingtime){
            return meetingtime.split(" ")[1]
        },
        showtimetable(){
            const that = this;
            that.timetableloading = true;
            that.timetable = [];

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getcustom';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        resultData.data.forEach(element => {
                            element["meetingtimestart"] = that.splitMeetingTime(element["meetingtimestart"]);
                            element["meetingtimeend"] = that.splitMeetingTime(element["meetingtimeend"]);
                        });

                        that.timetable = resultData.data;
                    }
                    that.timetableloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        openEditDialog(item){
            const that = this;
            that.selectedRecordUpdate = item;
            that.dialogUpdate = true;
        },
        openDeleteDialog(item){
            const that = this;
            that.selectedRecordDelete = item;
            that.dialogDelete = true;
        },
        getSubjectList(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getsubjects';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            json.data.forEach(element => {
                                that.disciplineitems.push({"label" : element["label"]+'('+element["value"]+')', "value": element["value"]});
                            });
                        }
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        updateRecord(){
            const that = this;
            that.updatebtnloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            if(that.selectedRecordUpdate.instructorname == null){
                that.selectedRecordUpdate.instructorname = ""
            }
            let record = {
                id: that.selectedRecordUpdate.id,
                strm: that.selectedRecordUpdate.strm,
                classsection: that.selectedRecordUpdate.classsection,
                subject: that.selectedRecordUpdate.subject,
                catalognbr: that.selectedRecordUpdate.catalognbr,
                classnbr: that.selectedRecordUpdate.classnbr,
                location: that.selectedRecordUpdate.location,
                enrlcap: that.selectedRecordUpdate.enrlcap,
                instructorname: that.selectedRecordUpdate.instructorname,
                meetingtimestart: "1/1/1900 "+that.selectedRecordUpdate.meetingtimestart,
                meetingtimeend: "1/1/1900 "+that.selectedRecordUpdate.meetingtimeend,
                acadgroup: that.selectedRecordUpdate.acadgroup,
                mon: that.selectedRecordUpdate.mon,
                tues: that.selectedRecordUpdate.tues,
                wed: that.selectedRecordUpdate.wed,
                thurs: that.selectedRecordUpdate.thurs,
                fri: that.selectedRecordUpdate.fri,
                facilityid: that.selectedRecordUpdate.facilityid,
                descrlong: that.selectedRecordUpdate.descrlong,
                descr: that.selectedRecordUpdate.descr,
                associatedclass: that.selectedRecordUpdate.associatedclass,
                ssrcomponent: that.selectedRecordUpdate.ssrcomponent,
                campus: that.selectedRecordUpdate.campus,
                sessioncode: that.selectedRecordUpdate.sessioncode
            }

            const formData = new FormData();
            formData.append("mode", "setcustom");
            formData.append("data", JSON.stringify(record));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Successful: "+data.message.toString(), "green");
                    that.showtimetable();
                    that.dialogUpdate = false;
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                }

                that.updatebtnloading = false;

            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.updatebtnloading = false;
            })
        },
        deleteRecord(){
            const that = this;
            that.deletebtnloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=deletecustom&data={"id":"'+that.selectedRecordDelete.id+'"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.setSnackbar("Successful: "+json.message.toString(), "green");
                        that.showtimetable();
                        that.dialogDelete = false;
                    }else {
                        that.setSnackbar("Warning: "+json.message.toString(), "orange");
                    }

                    that.deletebtnloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.deletebtnloading = false;
                })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.showtimetable();
        that.getSubjectList();
    }
}
</script>
<style scoped>
.v-data-table >>> .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
</style>